import { PropertyActivity } from '../shared/generated';
var ENDORSEMENT_PREFIX = 'https://storage.googleapis.com/jove-public-images/endorsements/';

var getFileDataMapInfo = function getFileDataMapInfo() {
  return {
    'PM001.0_UK.pdf': {
      key: 'pm001-uk',
      title: 'PM001: Property Management Endorsement',
      url: "".concat(ENDORSEMENT_PREFIX, "PM001.0_UK.pdf")
    },
    'PM001.1_UK.pdf': {
      key: 'pm0011-uk',
      title: 'PM001: Property Management Endorsement',
      url: "".concat(ENDORSEMENT_PREFIX, "PM001.1_UK.pdf")
    },
    'PS001.0_UK.pdf': {
      key: 'ps001-uk',
      title: 'PS001: Property Sourcing Endorsement',
      url: "".concat(ENDORSEMENT_PREFIX, "PS001.0_UK.pdf")
    },
    'PS001.1_UK.pdf': {
      key: 'ps0011-uk',
      title: 'PS001: Property Sourcing Endorsement',
      url: "".concat(ENDORSEMENT_PREFIX, "PS001.1_UK.pdf")
    },
    'EA001.0_UK.pdf': {
      key: 'ea001-uk',
      title: 'EA001: Estate Agency Endorsement',
      url: "".concat(ENDORSEMENT_PREFIX, "EA001.0_UK.pdf")
    },
    'EA001.1_UK.pdf': {
      key: 'ea0011-uk',
      title: 'EA001: Estate/Letting Agency Endorsement',
      url: "".concat(ENDORSEMENT_PREFIX, "EA001.1_UK.pdf")
    },
    'R2R01.0_UK.pdf': {
      key: 'r2r01-uk',
      title: 'RTR01: Residential Property Operator (Rent-to-Rent) Endorsement',
      url: "".concat(ENDORSEMENT_PREFIX, "R2R01.0_UK.pdf")
    },
    'R2R01.1_UK.pdf': {
      key: 'r2r01-uk',
      title: 'RTR01: Residential Property Operator (Rent-to-Rent) Endorsement',
      url: "".concat(ENDORSEMENT_PREFIX, "R2R01.1_UK.pdf")
    },
    'TPO01.0_UK.pdf': {
      key: 'tpo01-uk',
      title: 'TPO01: Property Ombudsman / Redress Scheme Endorsement',
      url: "".concat(ENDORSEMENT_PREFIX, "TPO01.0_UK.pdf")
    },
    'ID001.0_UK.pdf': {
      key: 'id001-uk',
      title: 'ID001: Property Sourcing and Rent-to-Rent Operators Endorsement',
      url: "".concat(ENDORSEMENT_PREFIX, "ID001.0_UK.pdf")
    },
    SEAI_BER_Assessor: {
      key: 'seai-ber-assessor',
      title: 'BER01: SEAI BER Assessor Endorsement',
      url: "".concat(ENDORSEMENT_PREFIX, "SEAI_BER_Assessor_v1.pdf")
    },
    'Endt_AC001.0_UK.pdf': {
      key: 'endt-ac001-uk',
      title: 'AC001: Accountancy – Scope of Services Endorsement',
      url: "".concat(ENDORSEMENT_PREFIX, "Endt_AC001.0_UK.pdf")
    },
    'Endt_AC002.0_UK.pdf': {
      key: 'endt-ac002-uk',
      title: 'AC002: Accountancy – Scope of Services Endorsement',
      url: "".concat(ENDORSEMENT_PREFIX, "Endt_AC002.0_UK.pdf")
    },
    'Endt_AC003.0_UK.pdf': {
      key: 'endt-ac003-uk',
      title: 'AC003: Accountancy – Scope of Services Endorsement',
      url: "".concat(ENDORSEMENT_PREFIX, "Endt_AC003.0_UK.pdf")
    }
  };
};

export var getEndorsementsLinkUrlByBusinessActivity = function getEndorsementsLinkUrlByBusinessActivity(files, businessActivity) {
  var fileDataMap = getFileDataMapInfo();

  var addIfIncludes = function addIfIncludes(codes, fileData) {
    if (fileData && codes.includes(businessActivity)) {
      files.add(fileData);
    }
  };

  addIfIncludes(['SV-018'], fileDataMap['PM001.1_UK.pdf']);
  addIfIncludes(['SV-018'], fileDataMap['R2R01.1_UK.pdf']);
  addIfIncludes(['SV-016'], fileDataMap['TPO01.0_UK.pdf']);
  addIfIncludes(['SV-016'], fileDataMap['ID001.0_UK.pdf']);
  addIfIncludes(['BCS-290'], fileDataMap['SEAI_BER_Assessor']);
};
export var getEndorsementsLinkUrlByActivitySplit = function getEndorsementsLinkUrlByActivitySplit(files, activitySplit) {
  var fileDataMap = getFileDataMapInfo();
  var keyList = Object.keys(activitySplit || {});

  var haveIncludeCodes = function haveIncludeCodes(codes) {
    return codes.some(function (code) {
      return keyList.includes(code) && activitySplit[code] > 0;
    });
  };

  if (haveIncludeCodes(['ACT049', 'ACT063'])) {
    files.add(fileDataMap['Endt_AC003.0_UK.pdf']);
  } else if (haveIncludeCodes(['ACT030', 'ACT037'])) {
    files.add(fileDataMap['Endt_AC002.0_UK.pdf']);
  } else if (haveIncludeCodes(['ACT008', 'ACT010', 'ACT013', 'ACT023', 'ACT024', 'ACT059', 'ACT075', 'ACT111'])) {
    files.add(fileDataMap['Endt_AC001.0_UK.pdf']);
  }
};

var getEndorsementsLinkUrlByPropertyActivities = function getEndorsementsLinkUrlByPropertyActivities(files, propertyActivities) {
  var fileDataMap = getFileDataMapInfo();

  if (propertyActivities.includes(PropertyActivity.ESTATE_PROPERTY_MANAGEMENT_NON_RICS)) {
    files.add(fileDataMap['PM001.1_UK.pdf']);
  }

  if (propertyActivities.includes(PropertyActivity.PROPERTY_SEARCH_AGENCY) || propertyActivities.includes(PropertyActivity.PROPERTY_SOURCING)) {
    files.add(fileDataMap['PS001.1_UK.pdf']);
  }

  if (propertyActivities.includes(PropertyActivity.ESTATE_AGENT_LETTING_AGENT)) {
    files.add(fileDataMap['EA001.1_UK.pdf']);
  }

  if (propertyActivities.includes(PropertyActivity.R2R_OPERATOR)) {
    files.add(fileDataMap['R2R01.1_UK.pdf']);
  }
};

export var getEndorsementsLinkUrlByQuoteData = function getEndorsementsLinkUrlByQuoteData(config) {
  var files = new Set();

  if (config !== null && config !== void 0 && config.businessActivity) {
    getEndorsementsLinkUrlByBusinessActivity(files, config === null || config === void 0 ? void 0 : config.businessActivity);
  }

  if (config !== null && config !== void 0 && config.propertyActivities) {
    getEndorsementsLinkUrlByPropertyActivities(files, config === null || config === void 0 ? void 0 : config.propertyActivities);
  }

  if (config !== null && config !== void 0 && config.activitySplit) {
    getEndorsementsLinkUrlByActivitySplit(files, config === null || config === void 0 ? void 0 : config.activitySplit);
  }

  return Array.from(files);
};